import React, { Component } from 'react';
import { ActivityIndicator } from 'antd-mobile';
import PropTypes from 'prop-types';
import { getStudyFiles, learnStatistics } from '../../../service/chat-service';
import style from './style.module.less';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

class Study extends Component {
  constructor(props) {
    super(props);
    document.title = '培训资料';

    this.state = {
      electList: [], // 选学
      mustLearnList: [], // 必学
      animating: false,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    this.setState({ animating: true });
    try {
      const must = await getStudyFiles(1);
      const elect = await getStudyFiles(2);
      this.setState({ electList: elect.data, mustLearnList: must.data, animating: false });
    } catch (e) {
      this.setState({ animating: false });
    }
  }

  /**
   * 点击学习
   */
  handleStudy = async (id, fileUrl, status) => {
    const { history } = this.props;
    const isPdf = fileUrl.indexOf('pdf') !== -1;
    if (status === 1) return;
    try {
      const { code } = await learnStatistics(id);
      if (code === 10000) {
        if (isPdf) {
          history.push(`/filePreview?fileUrl=${fileUrl}`);
        } else {
          history.push(`/video?fileUrl=${fileUrl}`);
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }

  /**
   * 渲染学习列表
   * @returns {*}
   */
  renderStudyList = (list) => {
    if (!list || list.length === 0) return null;

    return list.map((item) => (
      <div
        key={item.id}
        className={style.study}
        onClick={this.handleStudy.bind(this, item.id, item.fileUrl, item.status)}
        role="button"
        tabIndex={0}
      >
        <div className={style.studyTitle}>{item.name}</div>
        {item.status === 2 ? (
          <div className={style.noStudyStatus}>未学习</div>
        ) : (
          <div className={style.studyStatus}>已学习</div>
        )}
      </div>
    ));
  }

  render() {
    const { electList, mustLearnList, animating } = this.state;

    return (
      <div className={style.box}>
        <div className={style.title}>必学</div>
        {this.renderStudyList(mustLearnList)}
        <div className={style.title}>选学</div>
        {this.renderStudyList(electList)}

        <ActivityIndicator toast text="正在加载" animating={animating} />
      </div>
    );
  }
}

Study.propTypes = propTypes;

export default Study;
